import { Menu, Transition } from "@headlessui/react";
import React, { Fragment, useState } from "react";
import { FaUser } from "react-icons/fa";
import { FiUser } from "react-icons/fi";
import { LuMoreVertical } from "react-icons/lu";
import { PipelineIcon } from "../../../pages/modules/SelectedModuleView";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { onDeleteContact } from "../../../services/crm/contacts";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { toast } from "react-toastify";
import Spinner from "../../generic/Spinner";
import AddContactModal from "./AddContactModal";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import ContactDetailed from "../../../pages/modules/crm/ContactDetailed";

function ContactItem({ item }) {
  const queryClient = useQueryClient();
  const { config } = useStateGetter();
  const { setSidebarRenderView, setselectedEmpl } = useStateSetter();
  const [showedit, setshowedit] = useState(false);
  const { data, isPending, mutateAsync } = useMutation({
    mutationFn: () => onDeleteContact(item.id, config),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["contacts_list"] });

      toast.success("Deleted");
    },

    onError: () => {
      toast.error("Error deleting");
    },
  });
  return (
    <div className="border border-gray-400 px-3 py-5 flex justify-between  text-textbg rounded-md">
      {showedit && (
        <AddContactModal item={item} isedit={true} show={setshowedit} />
      )}

      <Spinner loading={isPending} />
      <div className="flex gap-2">
        <FiUser
          size={40}
          className=" p-3 rounded-full text-textbg  text-sm bg-faintBlue"
        />{" "}
        <div className="">
          <p className="font-[600]">{item.name}</p>
          <p className="font-[400] text-xs">{item.email}</p>
          <p className="font-light flex gap-2 text-xs mt-2">
            {" "}
            {item.type}
            <PipelineIcon />3
          </p>
        </div>
      </div>
      <Menu as="div" className="  self-center  relative  ">
        <div>
          <Menu.Button className="   p-1 flex text-sm rounded-full ">
            <LuMoreVertical className=" " />
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className=" absolute right-0 mt-2 w-48 rounded-[8px] shadow-md p-1 bg-white ring-1   focus:outline-none">
            <Menu.Item>
              <p
                onClick={() => {
                  setSidebarRenderView(<ContactDetailed />);
                  setselectedEmpl(item);
                }}
                className="text-semibold text-textbg text-sm cursor-pointer p-2 hover:bg-gray-100 "
              >
                View
              </p>
            </Menu.Item>
            <Menu.Item>
              <p
                onClick={() => {
                  setshowedit(true);
                }}
                className="text-semibold text-textbg text-sm cursor-pointer p-2 hover:bg-gray-100 "
              >
                Edit
              </p>
            </Menu.Item>
            <Menu.Item>
              <p
                onClick={async () => {
                  await mutateAsync();
                }}
                className="text-semibold text-textbg text-sm cursor-pointer p-2 hover:bg-gray-100 "
              >
                Delete
              </p>
            </Menu.Item>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
}

export default ContactItem;
